import { Component } from "react"
import PropTypes from "prop-types"

import * as DiffUtils from "./diff_utils"
import QueryField from "./query_field"
import Ingredient from "./ingredient"
import { StatusRow } from "./table_components"

class Query extends Component {
  constructor(props) {
    super(props)
    this.pathObjs = ["channel", "queries", this.props.query.id]
  }

  renderAttributes() {
    const { query, feedbackItems = {}, service } = this.props
    const serviceSlug =
      query.type === "deleted" ? this.props.originalChannel.slug : service.slug
    let fields = [
      {
        key: `query-name-${query.id}`,
        name: "Name",
        required: true,
        value: (
          <a
            target="_blank"
            href={`/services/${serviceSlug}/queries/${query.slug}`}
            rel="noreferrer"
          >
            {query.name}
          </a>
        ),
        fieldName: "name",
      },
    ]
    if (this.props.status !== "deleted") {
      fields = fields.concat([
        {
          key: `query-description-${query.id}`,
          name: "Description",
          required: true,
          value: query.description,
          fieldName: "description",
        },
        {
          key: `query-slug-${query.id}`,
          name: "Endpoint",
          required: true,
          value: query.slug,
          transform: value => `/${value}`,
          fieldName: "slug",
        },
      ])
    }
    const submenuIcons = JSON.parse(window.sessionStorage.submenuIcons)
    return fields.map(field => {
      field.diff = this.props.changes.find(
        diff =>
          diff.data &&
          diff.data.property === field.fieldName &&
          diff.path.length === 2
      )
      if (feedbackItems[field.fieldName]) {
        field.feedback = feedbackItems[field.fieldName]
        if (!submenuIcons.queriesFeedback) {
          this.props.setSessionFeedback("queries", submenuIcons)
        }
      }
      field.pathObjs = [...this.pathObjs, field.fieldName]
      return this.props.tableRow(field)
    })
  }

  prepareCollectionForRender = (items, collection) => {
    const { changes, query, diffStyle } = this.props
    if (diffStyle !== "none") {
      const itemsDeleted = DiffUtils.collectionDeletedItems(
        changes,
        this.props.originalChannel,
        ["queries", query, collection]
      )
      items = items.concat(itemsDeleted)
    }
    return DiffUtils.setupCollectionForRender(changes, items, [
      "queries",
      query,
      collection,
    ])
  }

  render() {
    const { changes, query, feedbackItems = {} } = this.props
    const queryFieldFeedback = feedbackItems.query_fields || {}
    const ingredientFeedback = feedbackItems.ingredients || {}
    const fieldsReordered = DiffUtils.collectionWasReordered(changes, [
      "queries",
      query,
      "query_fields",
    ])

    const queryFields = this.prepareCollectionForRender(
      query.query_fields,
      "query_fields"
    )
    const ingredients = this.prepareCollectionForRender(
      query.ingredients,
      "ingredients"
    )
    return (
      <table>
        <tbody>
          {this.props.diffStyle !== "none" && (
            <StatusRow status={this.props.status} />
          )}
          {this.props.diffStyle !== "none" && fieldsReordered && (
            <tr>
              <td colSpan="3" className="reordered">
                Query fields have been reordered.
              </td>
            </tr>
          )}
          {this.renderAttributes()}
          {this.props.status !== "deleted" && (
            <tr>
              <th>Query fields</th>
              <td>
                {queryFields.length > 0
                  ? queryFields.map(f => (
                      <QueryField
                        key={`query-field-${f.id}`}
                        originalChannel={this.props.originalChannel}
                        diffStyle={this.props.diffStyle}
                        queryField={f}
                        changes={f.changes}
                        status={f.type}
                        pathObjs={[...this.pathObjs, "query_fields"]}
                        feedbackItems={queryFieldFeedback[f.id]}
                        tableRow={this.props.tableRow}
                        setSessionFeedback={this.props.setSessionFeedback}
                      />
                    ))
                  : "None"}
              </td>
              <td className="no-feedback" />
            </tr>
          )}
          {this.props.status !== "deleted" && (
            <tr>
              <th>Ingredients</th>
              <td>
                {ingredients.length > 0
                  ? ingredients.map(ing => (
                      <Ingredient
                        key={`query-ingredient-${ing.id}`}
                        type="query"
                        diffStyle={this.props.diffStyle}
                        ingredient={ing}
                        changes={ing.changes}
                        status={ing.type}
                        pathObjs={[...this.pathObjs, "ingredients"]}
                        feedbackItems={ingredientFeedback[ing.id]}
                        tableRow={this.props.tableRow}
                      />
                    ))
                  : "None"}
              </td>
              <td className="no-feedback" />
            </tr>
          )}
        </tbody>
      </table>
    )
  }
}

Query.propTypes = {
  platformServiceUrl: PropTypes.string.isRequired,
  diffStyle: PropTypes.string.isRequired,
  service: PropTypes.object.isRequired,
  originalChannel: PropTypes.object,
  status: PropTypes.oneOf(["new", "deleted", "updated", "stale"]).isRequired,
  query: PropTypes.object.isRequired,
  changes: PropTypes.array.isRequired,
  feedbackItems: PropTypes.object,
  tableRow: PropTypes.func.isRequired, // Should be imported
  setSessionFeedback: PropTypes.func.isRequired,
}

export default Query
